// extracted by mini-css-extract-plugin
export default {"popover":"styled_popover__2BoHp"};